module.exports = __webpack_public_path__ + "img/RelativeRelationTypes.617cf336.svg";